import { useOutletContext } from 'react-router-dom'

import { QuickPerformance } from '@pages/IntroducingBroker/Dashboard/QuickPerformance/QuickPerformance'
import { useIBPerformance } from '@pages/IntroducingBroker/Dashboard/hooks/useIBPerformance'

import { DashboardContextValue } from '../../DashboardWrapper'

export const IBQuickPerformanceWidget = () => {
  const { data: ibPerformanceData, isLoading, dateRange, setDateRange } = useIBPerformance()
  const { currentLayout } = useOutletContext<DashboardContextValue>()

  return (
    <QuickPerformance
      isLoading={isLoading}
      ibPerformanceData={ibPerformanceData}
      dateRange={dateRange}
      setDateRange={setDateRange}
      isResizable={!currentLayout?.isPreset}
    />
  )
}
